import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionGroup, SelectionGroupItem, Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { WallHorizontal, WallDiagonal } from 'assets';
import { LayingType, LayingTypeCalculationPercentage, LayingTypeLabel } from './const';
import {
  ButtonContainer,
  HeaderContainer,
  LayerContainer,
  LayerThickness,
  AdditionalMaterialWrapper,
  SelectionGroupClassname,
  SelectionGroupItemClassname,
} from './styles';

const layingTypes = [
  {
    name: LayingType.horizontal,
    label: LayingTypeLabel[LayingType.horizontal],
    calculationPercentage: LayingTypeCalculationPercentage[LayingType.horizontal],
    getIcon: () => <WallHorizontal />,
  },
  {
    name: LayingType.diagonal,
    label: LayingTypeLabel[LayingType.diagonal],
    calculationPercentage: LayingTypeCalculationPercentage[LayingType.diagonal],
    getIcon: () => <WallDiagonal />,
  },
];

type TProps = {
  fieldName: string;
  onChangeValue?: () => void;
};

export const LayingTypeField = ({ fieldName, onChangeValue }: TProps) => {
  const { control, setValue } = useFormContext();
  const { mobile } = useBreakpoints() ?? {};
  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="h3" color="text-primary">
            Направление укладки
          </Typography>
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name={fieldName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectionGroup
              active={value}
              onChange={(_, layingTypeValue) => {
                onChange();
                setValue(fieldName, layingTypeValue);
                onChangeValue?.();
              }}
              variant="outline"
              size={mobile ? 's' : 'm'}
              className={SelectionGroupClassname}>
              {layingTypes.map(layingTypeItem => (
                <SelectionGroupItem
                  className={SelectionGroupItemClassname}
                  key={layingTypeItem.name}
                  value={layingTypeItem.name}
                  data-testid={`${layingTypeItem.name}-laying-type-select`}>
                  <LayerThickness>
                    {layingTypeItem.getIcon()}
                    <Typography variant="m" size="body_long" color="text-primary">
                      {layingTypeItem.label}
                    </Typography>
                    <AdditionalMaterialWrapper>
                      <Typography size="body_long" variant="s" color="text-secondary">
                        {`${layingTypeItem.calculationPercentage}`} запас материала
                      </Typography>
                    </AdditionalMaterialWrapper>
                  </LayerThickness>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
          )}
        />
      </LayerContainer>
    </>
  );
};
